var jade = require("/opt/codecombat/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (Math, view) {
jade_mixins["price"] = jade_interp = function(name, p){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var origPrice = p.priceStringNoSymbol()
if ( origPrice % 1 === 0)
{
origPrice = Math.floor(origPrice);
}
var salePrice = p.adjustedPriceStringNoSymbol()
if ( salePrice % 1 === 0)
{
salePrice = Math.floor(salePrice);
}
if ( origPrice == salePrice)
{
buf.push("<div" + (jade.attr("data-i18n", name, true, true)) + (jade.attr("data-i18n-options", {price:origPrice}, true, true)) + " class=\"price\"></div>");
}
else if ( view.basicCoupon && view.basicCoupon.duration === 'once')
{
buf.push("<div" + (jade.attr("data-i18n", name, true, true)) + (jade.attr("data-i18n-options", {price:origPrice}, true, true)) + " class=\"price strike-price\"></div><div data-i18n=\"subscribe.first_month_price\"" + (jade.attr("data-i18n-options", {price:salePrice}, true, true)) + " class=\"new-price\"></div>");
}
else
{
buf.push("<div><span" + (jade.attr("data-i18n", name, true, true)) + (jade.attr("data-i18n-options", {price:origPrice}, true, true)) + " class=\"old-price\"></span><span" + (jade.attr("data-i18n", name, true, true)) + (jade.attr("data-i18n-options", {price:salePrice}, true, true)) + " class=\"price\"></span></div>");
}
};
buf.push("<div class=\"modal-dialog\"><div class=\"modal-content\">");
if ( view.state === 'purchasing')
{
buf.push("<div data-i18n=\"buy_gems.purchasing\" class=\"alert alert-info\"></div>");
}
else if ( view.state === 'retrying')
{
buf.push("<div id=\"retrying-alert\" data-i18n=\"buy_gems.retrying\" class=\"alert alert-danger\"></div>");
}
else
{
buf.push("<img id=\"subscribe-background\" src=\"/images/pages/play/modal/subscribe-background-blank.png\"><h1 data-i18n=\"subscribe.subscribe_modal_title\"></h1><div id=\"close-modal\"><span class=\"glyphicon glyphicon-remove\"></span></div><div class=\"paper-area\">");
if ( view.subType === 'both-subs')
{
buf.push("<div data-i18n=\"[html]subscribe.comparison_blurb\" class=\"benefits-header text-center\"></div><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-5 option-col col-xs-offset-1\"><img src=\"/images/pages/play/modal/three-pets.png\"></div><div class=\"col-xs-6\"><ul class=\"features-list\"><li data-i18n=\"subscribe.feature_level_access\"></li><li data-i18n=\"subscribe.feature_heroes\"></li><li data-i18n=\"subscribe.feature_learn\"></li></ul></div></div><hr>");
if ( view.lifetimeProduct)
{
buf.push("<div class=\"short-row row\">");
if ( view.basicProduct)
{
buf.push("<div class=\"col-xs-5 option-col col-xs-offset-1\"></div><div class=\"option-col .col-xs-5\"><div data-i18n=\"subscribe.best_deal\" class=\"option-header best-deal\"></div></div>");
}
else
{
buf.push("<div class=\"option-col .col-xs-12\"><div data-i18n=\"subscribe.best_deal\" class=\"option-header best-deal\"></div></div>");
}
buf.push("</div>");
}
buf.push("<div class=\"row\">");
var secondRowClass = '.col-xs-5'
if ( view.basicProduct)
{
buf.push("<div class=\"col-xs-5 option-col col-xs-offset-1\">");
jade_mixins["price"]("subscribe.month_price", view.basicProduct);
buf.push("<div data-i18n=\"subscribe.stripe_description\" class=\"option-header price-subtext text-center\"></div><button class=\"btn btn-lg btn-illustrated purchase-button\"><span data-i18n=\"subscribe.buy_now\" class=\"buy-now-text\"></span><span class=\"buy-lock-icon\">&#x1F512;</span></button></div>");
}
else
{
var secondRowClass = '.col-xs-12'
}
if ( view.lifetimeProduct)
{
buf.push("<div" + (jade.cls(['option-col',secondRowClass], [null,true])) + ">");
jade_mixins["price"]("subscribe.lifetime_price", view.lifetimeProduct);
buf.push("<div data-i18n=\"subscribe.lifetime\" class=\"option-header price-subtext text-center\"></div>");
if ( view.paymentProcessor === 'PayPal')
{
buf.push("<div id=\"paypal-button-container\"></div>");
}
else
{
buf.push("<button class=\"stripe-lifetime-button btn btn-lg btn-illustrated\"><span data-i18n=\"subscribe.buy_now\" class=\"buy-now-text\"></span><span class=\"buy-lock-icon\">&#x1F512;</span></button>");
}
buf.push("</div>");
}
buf.push("</div></div>");
}
else
{
buf.push("<div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-5 text-center\"><img src=\"/images/pages/play/modal/heroes-and-pets.png\" class=\"left-image\"></div><div class=\"col-xs-7\"><div data-i18n=\"[html]subscribe.comparison_blurb\" class=\"benefits-header text-center\"></div><ul><li data-i18n=\"subscribe.feature_level_access\"></li><li data-i18n=\"subscribe.feature_heroes\"></li><li data-i18n=\"subscribe.feature_learn\"></li></ul>");
if ( view.lifetimeProduct)
{
buf.push("<div" + (jade.cls(['option-col',secondRowClass], [null,true])) + ">");
jade_mixins["price"]("subscribe.lifetime_price", view.lifetimeProduct);
buf.push("<div data-i18n=\"subscribe.lifetime\" class=\"option-header text-center\"></div>");
if ( view.paymentProcessor === 'PayPal')
{
buf.push("<div id=\"paypal-button-container\"></div>");
}
else
{
buf.push("<button class=\"stripe-lifetime-button btn btn-lg btn-illustrated\"><span data-i18n=\"subscribe.buy_now\" class=\"buy-now-text\"></span><span class=\"buy-lock-icon\">&#x1F512;</span></button>");
}
buf.push("</div>");
}
buf.push("</div></div></div>");
}
buf.push("<div class=\"support-blurb text-center\"><p><span data-i18n=\"subscribe.support_part1\"></span>" + (jade.escape(null == (jade_interp = " ") ? "" : jade_interp)) + "<a href=\"mailto:support@codecombat.com\" data-i18n=\"subscribe.support_part2\"></a></p></div></div>");
if ( view.state === 'declined')
{
buf.push("<div id=\"declined-alert\" class=\"alert alert-danger alert-dismissible\"><span data-i18n=\"buy_gems.declined\"></span><button type=\"button\" data-dismiss=\"alert\" class=\"close\"><span aria-hidden=\"true\">&times;</span></button></div>");
}
if ( view.state === 'error')
{
buf.push("<div id=\"error-alert\" class=\"alert alert-danger alert-dismissible\"><button type=\"button\" data-dismiss=\"alert\" class=\"close\"><span aria-hidden=\"true\">&times;</span></button><p>" + (jade.escape(null == (jade_interp = view.stateMessage) ? "" : jade_interp)) + "</p></div>");
}
if ( view.state === 'unknown_error')
{
buf.push("<div id=\"error-alert\" class=\"alert alert-danger alert-dismissible\"><button type=\"button\" data-dismiss=\"alert\" class=\"close\"><span aria-hidden=\"true\">&times;</span></button><p data-i18n=\"loading_error.unknown\"></p><p>" + (jade.escape(null == (jade_interp = view.stateMessage) ? "" : jade_interp)) + "</p></div>");
}
}
buf.push("</div></div>");}.call(this,"Math" in locals_for_with?locals_for_with.Math:typeof Math!=="undefined"?Math:undefined,"view" in locals_for_with?locals_for_with.view:typeof view!=="undefined"?view:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/templates/core/subscribe-modal.jade
// module id = 799
// module chunks = 0 9 12 13 15 16 79 80 81 82 83 84 85 86 87 88 89 90 91